import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem("userInfo") && (localStorage.getItem("userInfo") !== null) && localStorage.getItem("userInfo").length) {
    next();
    return;
  }
  next('/login');
}

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/Home",
      // redirect: "/auth/login",
      component: () => import("./layouts/frontend/Home.vue"),
      children: [
        {
          path: "/Home",
          name: "frontend",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/Home.vue")
        }
      ]
    },
    {
      path: "/",
      redirect: "/dashboard",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/dashboard/Dashboard.vue")
        },
        {
          path: "/folders",
          name: "folders",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/folders/folder.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Dossiers" },
              { title: "Tous", url: '/folders', active: true }
            ],
            pageTitle: "Tous les dossiers",
            rule: 'editor'
          }
        },
        {
          path: "/third-party",
          name: "thirdparty",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/thirdparty/thirdparty.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Third Party" },
              { title: "Tous", url: '/third-party', active: true }
            ],
            pageTitle: "Tous les Third Party",
            rule: 'editor'
          }
        },
        {
          path: "/folders/requests/:id/details",
          name: "folders_details",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/folders/detail.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Dossiers", url: '/folders' },
              { title: "Toutes les requêtes du dossier", active: true }
            ],
            pageTitle: "Dossier",
            rule: 'editor'
          }
        },
        {
          path: "/requests/assign",
          name: "requests_assign",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/me.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Demandes" },
              { title: "Tous", url: '/requests', active: true }
            ],
            pageTitle: "Mes requêtes",
            rule: 'editor'
          }
        },
        //demandes
        {
          path: "/requests",
          name: "requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/demandes/all.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Demandes" },
              { title: "Toutes", url: '/requests', active: true }
            ],
            pageTitle: "Toutes les demandes",
            rule: 'editor'
          }
        },
        {
          path: "/requests-received",
          name: "requests-received",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/demandes/received.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Demandes" },
              { title: "Reçues", url: '/requests-received', active: true }
            ],
            pageTitle: "Demandes reçues",
            rule: 'editor'
          }
        },
        {
          path: "/requests-in-progress",
          name: "requests-in-progress",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/demandes/inProgress.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "En cours", url: '/requests-in-progress', active: true }
            ],
            pageTitle: "Demandes en cours de traitement",
            rule: 'editor'
          }
        },
        {
          path: "/requests-closed",
          name: "requests-closed",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/demandes/closed.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Clôturées", url: '/requests/fencing', active: true }
            ],
            pageTitle: "Demandes Clôturées",
            rule: 'editor'
          }
        },
        {
          path: "/requests-suspended",
          name: "requests-suspended",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/demandes/suspended.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Clôturées", url: '/requests/suspended', active: true }
            ],
            pageTitle: "Demandes suspendues",
            rule: 'editor'
          }
        },
        {
          path: "/requests-canceled",
          name: "requests-canceled",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/demandes/canceled.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Clôturées", url: '/requests/canceled', active: true }
            ],
            pageTitle: "Demandes annulées",
            rule: 'editor'
          }
        },
        {
          path: "/requests/mail",
          name: "mail-requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/mailRequest/MailRequests"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Mail", url: '/requests/mail', active: true }
            ],
            pageTitle: "Demandes par mail",
            rule: 'editor'
          }
        },
        //incidents
        {
          path: "/incidents",
          name: "incidents",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/incidents/all.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Incidents" },
              { title: "Toutes", url: '/incidents', active: true }
            ],
            pageTitle: "Tous les incidents",
            rule: 'editor'
          }
        },
        {
          path: "/incidents-received",
          name: "incidents-received",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/incidents/received.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Incidents" },
              { title: "Reçus", url: '/incidents-received', active: true }
            ],
            pageTitle: "Incidents reçus",
            rule: 'editor'
          }
        },
        {
          path: "/incidents-in-progress",
          name: "incidents-in-progress",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/incidents/inProgress.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Incidents", url: "/incidents" },
              { title: "En cours", url: '/incidents-in-progress', active: true }
            ],
            pageTitle: "Incidents en cours de traitement",
            rule: 'editor'
          }
        },
        {
          path: "/incidents-closed",
          name: "incidents-closed",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/incidents/closed.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Incidents", url: "/incidents" },
              { title: "Clôturés", url: '/incidents/fencing', active: true }
            ],
            pageTitle: "Incidents Clôturés",
            rule: 'editor'
          }
        },
        {
          path: "/incidents-canceled",
          name: "incidents-canceled",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/incidents/canceled.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Incidents", url: "/incidents" },
              { title: "Clôturés", url: '/incidents/canceled', active: true }
            ],
            pageTitle: "Incidents annulés",
            rule: 'editor'
          }
        },
        {
          path: "/incidents-suspended",
          name: "incidents-suspended",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/incidents/suspended.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Incidents", url: "/incidents" },
              { title: "Clôturés", url: '/incidents/suspended', active: true }
            ],
            pageTitle: "Incidents suspendus",
            rule: 'editor'
          }
        },
        //activities
        {
          path: "/activities",
          name: "activities",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/activities/all.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Activitiés" },
              { title: "Toutes", url: '/activities', active: true }
            ],
            pageTitle: "Toutes les activités",
            rule: 'editor'
          }
        },
        {
          path: "/activities-received",
          name: "activities-received",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/activities/received.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Activités" },
              { title: "Reçues", url: '/activities-received', active: true }
            ],
            pageTitle: "Activités reçues",
            rule: 'editor'
          }
        },
        {
          path: "/activities-in-progress",
          name: "activities-in-progress",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/activities/inProgress.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Activités", url: "/activities" },
              { title: "En cours", url: '/activities-in-progress', active: true }
            ],
            pageTitle: "Activités en cours de traitement",
            rule: 'editor'
          }
        },
        {
          path: "/activities-closed",
          name: "activities-closed",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/activities/closed.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Activités", url: "/activities" },
              { title: "Clôturés", url: '/activities/fencing', active: true }
            ],
            pageTitle: "Activités Clôturés",
            rule: 'editor'
          }
        },
        {
          path: "/activities-suspended",
          name: "activities-suspended",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/activities/suspended.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Activités", url: "/activities" },
              { title: "Clôturés", url: '/activities/suspended', active: true }
            ],
            pageTitle: "Activités suspendues",
            rule: 'editor'
          }
        },
        {
          path: "/activities-canceled",
          name: "activities-canceled",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/activities/canceled.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Activités", url: "/activities" },
              { title: "Clôturés", url: '/activities/canceled', active: true }
            ],
            pageTitle: "Activités annulées",
            rule: 'editor'
          }
        },
        //problems
        {
          path: "/problems",
          name: "problems",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/problems/index.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Problèmes" },
              { title: "Tous", url: '/problems', active: true }
            ],
            pageTitle: "Tous les problèmes",
            rule: 'editor'
          }
        },
        {
          path: "/problems-in-progress",
          name: "problems-in-progress",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/problems/inProgress.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Problèmes" },
              { title: "En cours de traitement", url: '', active: true },
            ],
            pageTitle: "Problèmes en cours",
            rule: 'editor'
          }
        },
        {
          path: "/problems-closed",
          name: "problems-closed",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/problems/closed.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Problèmes" },
              { title: "Traités", url: '', active: true },
            ],
            pageTitle: "Tous les problèmes",
            rule: 'editor'
          }
        },
        {
          path: "/problems-details/:id",
          name: "problems-details",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/problems/details.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Problèmes" },
              { title: "Détails", url: '', active: true },
            ],
            pageTitle: "Détails",
            rule: 'editor'
          }
        },

        {
          path: "/requests/not-approved",
          name: "not-approved-requests",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/NotApprovedRequests"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes les demandes", url: "/requests" },
              { title: "En attente d'apporbation", url: '/requests/not-approved', active: true }
            ],
            pageTitle: "Demandes en attente d'approbation",
            rule: 'editor'
          }
        },
        {
          path: "/requests/:id/detail/:event",
          name: "single-request",
          beforeEnter: ifAuthenticated,
          component: () => import("./views/requests/SingleRequest.vue"),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Toutes mes demandes", url: "/requests" },
              { title: "Demande", url: '/requests/:id', active: true }
            ],
            pageTitle: "Demande",
            rule: 'editor'
          }
        },
        {
          path: '/chat',
          name: 'chat',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/chat/Chat.vue'),
          meta: {
            no_scroll: true,
          }
        },
        {
          path: '/profile',
          name: 'profile',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/profile/Profile'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Profil", url: '/profile', active: true }
            ],
            pageTitle: "Mon profil",
            rule: 'editor'
          }
        },
        {
          path: '/invoices/:id/detail',
          name: 'Factures',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/Invoices'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Factures", url: '/invoices', active: true }
            ],
            pageTitle: "Liste des factures",
            rule: 'editor'
          }
        },
        {
          path: '/invoices',
          name: 'bills',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/bills'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Factures", url: '/invoices', active: true }
            ],
            pageTitle: "Liste des factures",
            rule: 'editor'
          }
        },
        {
          path: '/bills/:id/payment',
          name: 'bill_payment',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/payment'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Reglement", url: '/payments', active: true }
            ],
            pageTitle: "Liste des réglements de la facture",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/invoices',
          name: 'FacturesUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/uploads/InvoiceUpload'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Uploads", url: '/uploads/invoices', active: true }
            ],
            pageTitle: "Uploader des factures",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/invoices/:id/results',
          name: 'ResultsInvoiceUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/invoices/uploads/InvoiceResult'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Uploads", url: "/" },
              { title: "Résultats", url: '/uploads/invoices/results', active: true }
            ],
            pageTitle: "Resultats de l'uploads",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/payments',
          name: 'reglementUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/reglement/uploadList'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Upload", url: '/uploads/payments', active: true }
            ],
            pageTitle: "Uploader les réglements",
            rule: 'editor'
          }
        },
        {
          path: '/uploads/payments/:id/results',
          name: 'ResultsPaymentUpload',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/reglement/InvoiceResult'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Uploads", url: "/" },
              { title: "Résultats", url: '/uploads/invoices/results', active: true }
            ],
            pageTitle: "Resultats de l'uploads",
            rule: 'editor'
          }
        },
        {
          path: '/payments/:id/detail',
          name: 'Payments',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/reglement/payment'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Reglement", url: '/payments', active: true }
            ],
            pageTitle: "Liste des réglements",
            rule: 'editor'
          }
        },
        {
          path: '/clients',
          name: 'clients',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/clients/Clients'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Clients", url: '/clients', active: true }
            ],
            pageTitle: "Clients",
            rule: 'editor'
          }
        },
        {
          path: '/clients/import-history/:id',
          name: 'clients-import-history',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/clients/historyImport'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Clients", url: '/clients', active: false },
              { title: "Historique d'importation", url: '/clients', active: true }
            ],
            pageTitle: "Historique d'importation de clients",
            rule: 'editor'
          }
        },
        {
          path: '/clients/:id',
          name: 'clients-details',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/clients/ClientDetails'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Tous les Clients", url: "/clients" },
              { title: "e-Business Afrique", url: '/clients/:id', active: true }
            ],
            pageTitle: "Client e-Business Afrique",
            rule: 'editor'
          }
        },
        {
          path: '/services',
          name: 'services',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/services/Services'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Services", url: '/services', active: true }
            ],
            pageTitle: "Services",
            rule: 'editor'
          }
        },
        {
          path: '/segments',
          name: 'segments',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/segments/Segments'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Segments", url: '/segments', active: true }
            ],
            pageTitle: "Segments",
            rule: 'editor'
          }
        },
        {
          path: '/approbations',
          name: 'approbations',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/approbations/Approbations'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Chaînes d'approbations", url: '/approbations', active: true }
            ],
            pageTitle: "Chaînes d'approbations",
            rule: 'editor'
          }
        },
        {
          path: '/categories',
          name: 'categories',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/categories/Categories'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Type de demandes", url: '/categories', active: true }
            ],
            pageTitle: "Type de demandes",
            rule: 'editor'
          }
        },
        {
          path: '/types',
          name: 'types',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/types/Types'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Sous type de demandes", url: '/types', active: true }
            ],
            pageTitle: "Sous type de demandes",
            rule: 'editor'
          }
        },
        {
          path: '/users',
          name: 'users',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/admin/users/Users'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Utilisateurs", url: '/users', active: true }
            ],
            pageTitle: "Utilisateurs",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/manager',
          name: 'stat_manager',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/manager/manager'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '/users', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/globales',
          name: 'stat_req',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/requestStat'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '', active: true },
              { title: "Globales", url: '', active: true },
            ],
            pageTitle: "Statistiques globales",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/specifics',
          name: 'stat_ebu',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '', active: true },
              { title: "Statistiques Spécifiques", url: '/statistics/ebu', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex',
          name: 'stat_cex',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/request-realtime-period',
          name: 'stat_cex_realtime_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/requestRealtimePeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex' },
              { title: "Requêtes à temps réel par période", url: '#', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/specifics/agent-with-realtime',
          name: 'stat_cex_agent_with_realtime',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/agentWithRealTime'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '' },
              { title: "Statistiques spécifiques", url: '/statistics/specifics' },
              { title: "Agents par période", url: '#', active: true }
            ],
            pageTitle: "Agents par période",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/plainte-period',
          name: 'stat_cex_plainte_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/plainteWithPeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex' },
              { title: "Total plaintes par période", url: '#', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/request-call-reason-period',
          name: 'stat_cex_call_reason',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/callReason'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex' },
              { title: "Call reason par période", url: '#', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/specifics/request-canal',
          name: 'stat_specifics_request_canal',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/requestCanal'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '' },
              { title: "Spécifiques", url: '/statistics/specifics' },
              { title: "par canal", url: '#', active: true }
            ],
            pageTitle: "Statistiques par canal",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/approbation',
          name: 'stat_cex_request_approbation',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/approbation'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex' },
              { title: "Approbation par période", url: '#', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/cex/sla-category-period',
          name: 'stat_cex_sla_category_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/cex/sla'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques CEX", url: '/statistics/cex' },
              { title: "Sla par catégorie et par période", url: '#', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/service-period',
          name: 'stat_ebu_service_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/servicePeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '' },
              { title: "Spécifiques", url: '/statistics/specifics' },
              { title: "Reporting par service et par periode", url: '', active: true }
            ],
            pageTitle: "Spécifiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/garphe-nature-period',
          name: 'stat_ebu_nature_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/grapheNature'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu' },
              { title: "Graphe des requêtes par nature et sur une période défini", url: '#', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/specifics/total-request',
          name: 'stat_specifics_total_request',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/totalRequest'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '' },
              { title: "Statistiques spécifics", url: '/statistics/specifics' },
              { title: "Total des demandes", url: '#', active: true }
            ],
            pageTitle: "Total des demandes",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/history',
          name: 'stat_ebu_history',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/history'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '' },
              { title: "Spécifiques", url: '/statistics/specifics' },
              { title: "Top 10 des clients par période", url: '#', active: true }
            ],
            pageTitle: "Top 10 clients par période",
            rule: 'editor'
          }
        },
        {
          path: 'statistics/ebu/history-by-group',
          name: 'stat_ebu_history_by_group',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/totalByGroup'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques EBU", url: '/statistics/ebu' },
              { title: "Plainte reçue par mail et par CCMT par période", url: '#', active: true }
            ],
            pageTitle: "Statistiques",
            rule: 'editor'
          }
        },
        {
          path: '/statistics/ebu/call-reason-period',
          name: 'stat_ebu_call_reason_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/callReason'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '' },
              { title: "Spécifiques", url: '/statistics/specifics' },
              { title: "Types et sous-types par période", url: '#', active: true }
            ],
            pageTitle: "Types et sous-types par période",
            rule: 'editor'
          }
        },
        {
          path: '/statistics/specifics/sla-category-period',
          name: 'stat_specifics_sla_category_period',
          beforeEnter: ifAuthenticated,
          component: () => import('./views/stats/ebu/slaCategoryPeriod'),
          meta: {
            breadcrumb: [
              { title: "Tableau de bord", url: "/" },
              { title: "Statistiques", url: '' },
              { title: "Statistiques spécifics", url: '/statistics/specifics' },
              { title: "SLA par type de demande et par période", url: '#', active: true }
            ],
            pageTitle: "SLA par type de demande et par période",
            rule: 'editor'
          }
        },
      ]
    },
    {
      path: "",
      component: () => import("./layouts/full-page/FullPage.vue"),
      children: [
        {
          path: "/login",
          name: "login",
          component: () => import("./views/auth/Login.vue")
        },
        {
          path: "/password-reset",
          name: "password",
          component: () => import("./views/auth/ForgotPassword.vue")
        }
      ]
    }
  ]
});


export default router
